import { useCallback, useState } from 'react';
import { useOnHash } from '../SiteContext/useHashListener';
import useHistory from '../Router/useHistory';

const COOKIE_CONSENT_URL_HASH = '#cookie-consent';

export default function () {
  const { replace, location } = useHistory();
  const [isVisible, setIsVisible] = useState(() => location?.hash === COOKIE_CONSENT_URL_HASH);

  const onHashChange = useCallback((_prev: string, hash: string) => {
    setIsVisible(hash === COOKIE_CONSENT_URL_HASH);
  }, []);
  useOnHash(COOKIE_CONSENT_URL_HASH, onHashChange);

  const hide = useCallback(() => {
    replace({ search: location?.search, hash: '' });
  }, [location?.search]);
  const show = useCallback(() => {
    replace({ search: location?.search, hash: COOKIE_CONSENT_URL_HASH });
  }, [location?.search]);

  return {
    isVisible,
    hide,
    show,
  };
}
